(function() {
  if (typeof SearchForm === 'undefined') return;
  class MainSearch extends SearchForm {
    constructor() {
      super();
      this.allSearchInputs = document.querySelectorAll('input[type="search"]');
      this.setupEventListeners();
    }

    setupEventListeners() {
      let allSearchForms = [];
      this.allSearchInputs.forEach(input => allSearchForms.push(input.form))
      this.input.addEventListener('focus', this.onInputFocus.bind(this));
      if (allSearchForms.length < 2) return;
      allSearchForms.forEach(form =>
        form.addEventListener('reset', this.onFormReset.bind(this))
      );
      this.allSearchInputs.forEach(input =>
        input.addEventListener('input', this.onInput.bind(this))
      );
    }

    onFormReset(event) {
      super.onFormReset(event);
      if (super.shouldResetForm()) {
        this.keepInSync('', this.input);
      }
    }

    onInput(event) {
      if (this._syncing) return;
      if (window.__searchInputSyncing) return;
      if (event.isTrusted === false) return;
      var now = Date.now();
      if (now - (window.__searchLastInputTime || 0) < 80) return;
      window.__searchLastInputTime = now;
      var target = event.target;
      this.keepInSync(target.value, target);
    }

    onInputFocus() {
      const isSmallScreen = window.innerWidth < 750;
      if (isSmallScreen) {
        this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    keepInSync(value, target) {
      var self = this;
      self._syncing = true;
      window.__searchInputSyncing = true;
      window.__searchLastInputTime = Date.now();
      try {
        this.allSearchInputs.forEach(function (input) {
          if (input !== target) input.value = value;
        });
      } finally {
        requestAnimationFrame(function () {
          self._syncing = false;
          window.__searchInputSyncing = false;
        });
      }
    }
  }
  customElements.define('main-search', MainSearch);
})();
